import { useMutation, useQueryClient } from "@tanstack/react-query";
import UserNotification from "util/UserNotification";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import { DATA_LAKE_API_ROUTES } from "data-lake/Constants";
const onDeleteDataLakeRetrievalOperation = ({
  streamId,
  retrievalOperationId
}) => fetch("DELETE", qualifyUrl(DATA_LAKE_API_ROUTES.DataLakeAPIController.delete(streamId, retrievalOperationId).url));
const useDataLakeRetrievalMutation = () => {
  const queryClient = useQueryClient();
  const { mutateAsync: onDeleteDataLakeRetrievalOperationMutation } = useMutation({
    mutationFn: onDeleteDataLakeRetrievalOperation,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["data-lake"]
      });
      UserNotification.success(
        "The messages from the selected retrieval have been successfully deleted.",
        "Deletion of Data Lake retrieval"
      );
    },
    onError: (errorThrown) => {
      UserNotification.error(
        `Deleting messages from the selected retrieval failed with status: ${errorThrown}`,
        "Could not delete Data Lake retrieval"
      );
    }
  });
  return {
    onDeleteDataLakeRetrievalOperationMutation
  };
};
export default useDataLakeRetrievalMutation;
